import {
  Col,
  Row,
} from 'antd';
import React from 'react';
import GeneratedTestcaseModuleListViewItem from './GeneratedTestcaseModuleListViewItem';
import ClientSidePagination from '../../../components/Pagination/ClientSidePagination';

interface GeneratedTestcaseModuleListViewProps {
  testModules: any[]
  deleteModule: (moduleId: string) => Promise<boolean>
  currentPage: number
  pageSize: number
  total: number
  onPaginationChange: (page: number, pageSize: number) => void
}

const GeneratedTestcaseModuleListView = ({
  testModules,
  deleteModule,
  currentPage,
  pageSize,
  total,
  onPaginationChange,
}: GeneratedTestcaseModuleListViewProps) => {
  const moduleList = testModules.map((module: any) => (
    <GeneratedTestcaseModuleListViewItem
      module={module}
      key={module.moduleId || module.requirementId}
      deleteModule={deleteModule}
    />
  ));

  return (
    <div className="fp_list">
      <Row justify="space-between" className="fp_list_title">
        <Col span={6}><p>Module Name</p></Col>
        <Col span={13}>
          <Row>
            <Col span={18}>
              <p>Created At</p>
            </Col>
          </Row>
        </Col>
      </Row>
      {moduleList}
      <ClientSidePagination
        currentPage={currentPage}
        total={total}
        pageSize={pageSize}
        onPaginationChange={onPaginationChange}
      />
    </div>
  );
};

export default GeneratedTestcaseModuleListView;
